var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSelfie(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "\\uD0C0\\uC6D0_377",
    x: 0,
    y: 0,
    width: 111,
    height: 111,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#b1e7e7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_wm",
    transform: "translate(12 12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_964",
    "data-name": "\\uADF8\\uB8F9 964",
    transform: "translate(-161 -344.859)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 149, 332.86)",
    filter: "url(#\\uD0C0\\uC6D0_377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_377-2",
    "data-name": "\\uD0C0\\uC6D0 377",
    cx: 40.5,
    cy: 40.5,
    r: 40.5,
    transform: "translate(12 12)",
    fill: "#b1e7e7"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "woman-user-svgrepo-com",
    transform: "translate(-13.741 9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_920",
    "data-name": "\\uD328\\uC2A4 920",
    d: "M71.642,246.135l.054,7.1h0c0,.076,0,.151.005.227s0,.138,0,.206a18.188,18.188,0,0,0,8.8,15.023h.026a18.1,18.1,0,0,0,9.519,2.6l4.267-.033,22.293-25.468Z",
    transform: "translate(-40.297 -215.788)",
    fill: "#535572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_921",
    "data-name": "\\uD328\\uC2A4 921",
    d: "M255.847,245.962l.193,25.3,4.267-.033a18.1,18.1,0,0,0,9.479-2.75h.026a18.189,18.189,0,0,0,8.572-15.155c0-.069,0-.137,0-.206s0-.151,0-.227h0l-.054-7.1Z",
    transform: "translate(-202.017 -215.787)",
    fill: "#46475a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_922",
    "data-name": "\\uD328\\uC2A4 922",
    d: "M165.654,378.68a14.054,14.054,0,0,0-24.666,8.923,32.11,32.11,0,0,0,4.223,1.646q.617.192,1.244.359l.165.043a32.486,32.486,0,0,0,16.864-.129l.164-.046q.624-.177,1.238-.378c.712-.233,1.413-.493,2.1-.774.421-.171.839-.348,1.251-.536q.425-.195.845-.4A13.994,13.994,0,0,0,165.654,378.68Z",
    transform: "translate(-101.178 -328.202)",
    fill: "#e8c6b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_923",
    "data-name": "\\uD328\\uC2A4 923",
    d: "M199,447.3a4.919,4.919,0,0,0-1.349.175,8.714,8.714,0,0,1-4.491.034,4.927,4.927,0,0,0-1.352-.154,5.038,5.038,0,0,0-4.8,5.056v.039l.013,1.7a32.487,32.487,0,0,0,16.864-.129l-.013-1.7v-.039A5.039,5.039,0,0,0,199,447.3Z",
    transform: "translate(-141.587 -392.698)",
    fill: "#ab5034",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_965",
    "data-name": "\\uADF8\\uB8F9 965",
    transform: "translate(39.81 50.478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_924",
    "data-name": "\\uD328\\uC2A4 924",
    d: "M144.284,414.857a14,14,0,0,0-3.3,8.76,32.108,32.108,0,0,0,4.223,1.646q.617.192,1.244.359l.165.043-.018-2.4A16.786,16.786,0,0,0,144.284,414.857Z",
    transform: "translate(-140.988 -414.694)",
    fill: "#ce9276"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_925",
    "data-name": "\\uD328\\uC2A4 925",
    d: "M327.312,413.52a16.81,16.81,0,0,0-2.188,8.443l.018,2.4.164-.046q.624-.177,1.238-.378c.712-.233,1.413-.493,2.1-.774.421-.171.839-.348,1.251-.536q.425-.195.845-.4A14,14,0,0,0,327.312,413.52Z",
    transform: "translate(-302.646 -413.52)",
    fill: "#ce9276"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_926",
    "data-name": "\\uD328\\uC2A4 926",
    d: "M207.2,378.68a14.054,14.054,0,0,0-18.89-2.151,10.541,10.541,0,0,0,13.354,2.462,2.789,2.789,0,0,1,3.347.441,12.126,12.126,0,0,1,1.177,1.364,11.878,11.878,0,0,1,2.343,7l0,.527c.421-.171.839-.348,1.251-.536q.425-.195.845-.4A14,14,0,0,0,207.2,378.68Z",
    transform: "translate(-142.723 -328.202)",
    fill: "#ab5034",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_927",
    "data-name": "\\uD328\\uC2A4 927",
    d: "M109.979,102.725l7.625,21.751a19.682,19.682,0,0,0,29.105-11.362,6.323,6.323,0,0,0,9.2-5.911,6.354,6.354,0,0,0-3.871-5.548,6.221,6.221,0,0,0-1.836-.466c-.07-.008-.142-.013-.214-.018l-9.22-9.08a13.372,13.372,0,0,0-18.91.144h0l-1.555.012a10.4,10.4,0,0,0-10.319,10.478h0",
    transform: "translate(-73.954 -77.474)",
    fill: "#e1b872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_928",
    "data-name": "\\uD328\\uC2A4 928",
    d: "M69.292,156.493v-.007a.72.72,0,0,0-.751-.706q-.22.007-.441.009a18,18,0,0,1-11.975-4.441c-.054-.047-.107-.094-.161-.144-.2-.178-.39-.358-.57-.536-1-.979-2.133-2.083-2.892-2.815a6.106,6.106,0,0,0-5.369-1.285c-2.955.639-5.407,3.2-7.091,7.413a2.165,2.165,0,0,1-2.78,1.229,2.1,2.1,0,0,1-1.238-1.415c-.4-.168-.795-.392-1.139-.569a6.3,6.3,0,0,0-2.868-.664c-.148,0-.3.008-.445.019a6.324,6.324,0,1,0,3.457,11.892,19.727,19.727,0,0,0,8.62,11.074,24.92,24.92,0,0,0,6.118.772A19.676,19.676,0,0,0,69.292,156.493Z",
    transform: "translate(0 -128.543)",
    fill: "#ecce93"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_378",
    "data-name": "\\uD0C0\\uC6D0 378",
    cx: 2.108,
    cy: 2.108,
    r: 2.108,
    transform: "translate(29.958 28.233)",
    fill: "#e1b872"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_379",
    "data-name": "\\uD0C0\\uC6D0 379",
    cx: 2.108,
    cy: 2.108,
    r: 2.108,
    transform: "translate(73.524 27.901)",
    fill: "#d5a150"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_929",
    "data-name": "\\uD328\\uC2A4 929",
    d: "M102.294.2a5.557,5.557,0,0,0-7.011,5.41,18.272,18.272,0,0,0-18.13,18.409,6.3,6.3,0,0,1,2.868.664c1.048.541,2.588,1.514,3.175.033,4.353-10.965,12.782-9.934,15.9-6.924.715.689,1.763,1.711,2.908,2.831q.248.245.508.477l.126.113a15.77,15.77,0,0,0,13.465,3.633,13.766,13.766,0,0,0,2.354-.725,6.316,6.316,0,0,1,2.7-.423c.072.005.143.01.214.018l0-.035A26.011,26.011,0,0,0,102.294.2Z",
    transform: "translate(-45.134 0)",
    fill: "#46475a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_930",
    "data-name": "\\uD328\\uC2A4 930",
    d: "M257.28,22.125a11.156,11.156,0,0,1,3.31-.463A26.023,26.023,0,0,0,241.705.2a5.531,5.531,0,0,0-5.67,1.745,3.448,3.448,0,0,0-.088.556l3.3,10.31.015.057a13.657,13.657,0,0,0,3.638,6.253c.137.135.283.272.436.409l.018.016.094.084a13.642,13.642,0,0,0,9.13,3.4,8.984,8.984,0,0,0,2.534-.257C256.005,22.507,256.687,22.29,257.28,22.125Z",
    transform: "translate(-184.546 -0.001)",
    fill: "#535572"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_931",
    "data-name": "\\uD328\\uC2A4 931",
    d: "M81.758,62.69a2.093,2.093,0,0,0,2.521-.987,16.271,16.271,0,0,1,4.352-5.3,11.3,11.3,0,0,1,6.807-2.406,10.759,10.759,0,0,1,3.42.533.636.636,0,0,0,.81-.774l0-.013-2.529-7.8A18.277,18.277,0,0,0,79.279,61.051a1.092,1.092,0,0,0,.93,1.274,8.279,8.279,0,0,1,1.538.361Z",
    transform: "translate(-46.987 -40.336)",
    fill: "#656890"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_966",
    "data-name": "\\uADF8\\uB8F9 966",
    transform: "translate(43.769 22.743)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_932",
    "data-name": "\\uD328\\uC2A4 932",
    d: "M178.7,187.536a7.324,7.324,0,0,0-4.559.035,1.054,1.054,0,1,0,.667,2,5.23,5.23,0,0,1,3.255-.025,1.054,1.054,0,0,0,.638-2.01Z",
    transform: "translate(-173.421 -187.082)",
    fill: "#46475a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_933",
    "data-name": "\\uD328\\uC2A4 933",
    d: "M293.83,186.656a7.323,7.323,0,0,0-4.559.035,1.054,1.054,0,1,0,.667,2,5.23,5.23,0,0,1,3.255-.025,1.054,1.054,0,0,0,.638-2.009Z",
    transform: "translate(-274.496 -186.31)",
    fill: "#46475a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_967",
    "data-name": "\\uADF8\\uB8F9 967",
    transform: "translate(44.715 28.014)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_380",
    "data-name": "\\uD0C0\\uC6D0 380",
    cx: 2.108,
    cy: 2.108,
    r: 2.108,
    transform: "translate(0 0.107)",
    fill: "#474641"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_381",
    "data-name": "\\uD0C0\\uC6D0 381",
    cx: 2.108,
    cy: 2.108,
    r: 2.108,
    transform: "translate(14.052)",
    fill: "#474641"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_934",
    "data-name": "\\uD328\\uC2A4 934",
    d: "M237.99,277.472a3.142,3.142,0,0,1-2.243-.909,1.054,1.054,0,0,1,1.479-1.5,1.054,1.054,0,0,0,1.49-.011,1.054,1.054,0,0,1,1.5,1.479A3.143,3.143,0,0,1,237.99,277.472Z",
    transform: "translate(-184.094 -241.198)",
    fill: "#8d472e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_968",
    "data-name": "\\uADF8\\uB8F9 968",
    transform: "translate(41.293 31.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_935",
    "data-name": "\\uD328\\uC2A4 935",
    d: "M155.605,264.329l-1.405.011a1.054,1.054,0,1,1-.016-2.108l1.405-.011a1.054,1.054,0,0,1,.016,2.108Z",
    transform: "translate(-153.138 -262.056)",
    fill: "#e1b872"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_936",
    "data-name": "\\uD328\\uC2A4 936",
    d: "M332.9,262.976l-1.405.011a1.054,1.054,0,0,1-.016-2.108l1.405-.011a1.054,1.054,0,1,1,.016,2.108Z",
    transform: "translate(-308.791 -260.868)",
    fill: "#e1b872"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfie);
export default __webpack_public_path__ + "static/media/selfie.91a5ea3e96dd918a45d3cd04b44963d6.svg";
export { ForwardRef as ReactComponent };